import styled, { css } from 'styled-components';

import { NextImageWithLoader } from '@/components/NextImageWithLoader';

import { Typography } from '../../../../Typography';

export const Wrapper = styled.div<{ $isActive: boolean }>`
  display: inline-block;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    &:hover {
      img {
        transform: scale(1.1);
        transition: all 0.5s linear;
      }
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2.5px;
      background-color: ${theme.colors.black};
      transform: scaleX(0);
      transform-origin: bottom left;
      transition: transform 0.5s ease-out;
    }
    ${theme.media.md.up} {
      &:hover::after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }
    }
  `}

  ${({ $isActive }) =>
    $isActive &&
    css`
      &::after {
        transform: scaleX(1);
        transform-origin: bottom right;
      }
    `}
`;
export const NavQuickImgBox = styled.div`
  height: 103px;
  max-width: 160px;
  min-width: 160px;
  overflow: hidden;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      height: 164px;
      max-width: 244px;
      min-width: 244px;
    }
  `}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const Label = styled(Typography)<{ $isActive?: boolean }>`
  text-transform: uppercase;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5};
    line-height: ${theme.fontSizes.h4};
    font-weight: 500;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h4};
      line-height: 27px;
    }
  `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: 600;
    `}
`;

export const TopLabel = styled.span<{
  $backgroundColor?: string;
}>`
  text-transform: uppercase;
  display: inline-block;
  ${({ $backgroundColor, theme }) => css`
    font-family: ${theme.fontFamilies.breitlingFont};
    font-size: ${theme.fontSizes.h4};
    line-height: 25px;
    line-height: 40px;
    font-weight: 400;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h3Mobile};
    }
    background: ${$backgroundColor ? $backgroundColor : theme.colors.white};
  `}
`;

export const NavQuickImg = styled(NextImageWithLoader)`
  position: relative;
  width: 100%;
  object-fit: cover;

  margin-bottom: -2px;
  max-width: 160px;
  min-width: 160px;
  height: 103px;
  ${({ theme }) => theme.media.md.up} {
    min-width: 244px;
    height: 164px;
  }
`;
